import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const VideoDisplay = ({ localVideoRef, remoteVideoRef, isVideoOff, isScreenSharing, remoteStream }) => {
  const [localPosition, setLocalPosition] = useState('bottom-right');

  const positionClasses = {
    'top-left': 'top-4 left-4',
    'top-right': 'top-4 right-4',
    'bottom-left': 'bottom-4 left-4',
    'bottom-right': 'bottom-4 right-4'
  };

  const cyclePosition = () => {
    const positions = ['bottom-right', 'bottom-left', 'top-right', 'top-left'];
    const currentIndex = positions?.indexOf(localPosition);
    const nextIndex = (currentIndex + 1) % positions?.length;
    setLocalPosition(positions?.[nextIndex]);
  };

  return (
    <div className="relative w-full h-full bg-[#111827] rounded-xl overflow-hidden">
      {/* Remote Video (Main Display) */}
      <div className="absolute inset-0 flex items-center justify-center">
        {remoteStream ? (
          <video
            ref={remoteVideoRef}
            autoPlay
            playsInline
            className="w-full h-full object-contain"
          />
        ) : (
          <div className="text-center">
            <div className="w-24 h-24 bg-[#374151] rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="User" size={48} color="#9CA3AF" />
            </div>
            <p className="text-gray-400 text-lg font-medium">Waiting for participant...</p>
            <p className="text-gray-500 text-sm mt-2">They will appear here once connected</p>
          </div>
        )}
      </div>
      {/* Local Video (Picture-in-Picture) */}
      <div
        className={`absolute ${positionClasses?.[localPosition]} z-10 group cursor-pointer`}
        onClick={cyclePosition}
      >
        <div className="relative w-64 h-48 bg-[#1F2937] rounded-xl overflow-hidden border-2 border-[#374151] shadow-2xl transition-transform hover:scale-105">
          {isVideoOff ? (
            <div className="absolute inset-0 flex items-center justify-center bg-[#1F2937]">
              <div className="text-center">
                <div className="w-16 h-16 bg-[#374151] rounded-full flex items-center justify-center mx-auto mb-2">
                  <Icon name="User" size={32} color="#9CA3AF" />
                </div>
                <p className="text-gray-400 text-sm">Camera Off</p>
              </div>
            </div>
          ) : (
            <video
              ref={localVideoRef}
              autoPlay
              playsInline
              muted
              className="w-full h-full object-cover mirror"
            />
          )}

          {/* Position Indicator */}
          <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity">
            <div className="bg-black/60 rounded-lg px-2 py-1">
              <Icon name="Move" size={16} color="#FFFFFF" />
            </div>
          </div>

          {/* Screen Sharing Badge */}
          {isScreenSharing && (
            <div className="absolute bottom-2 left-2 bg-blue-600 rounded-lg px-2 py-1 flex items-center gap-1">
              <Icon name="Monitor" size={14} color="#FFFFFF" />
              <span className="text-white text-xs font-medium">Sharing</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VideoDisplay;